export default "__VITE_PUBLIC_ASSET__bfe08994__"